import React from "react";
import { SectionTitleComponent } from "../../../components/section-title.component";

interface ILegalAdviserProfileComponentProps { }

export const LegalAdviserProfileComponent: React.FC<
    ILegalAdviserProfileComponentProps
> = (props: ILegalAdviserProfileComponentProps) => {
    const section = {
        title: "Legal Adviser Profile",
        subTitle:
            "Meet Mr. P.K. Date – Our Legal Expert in Provident Fund Matters",
    };

    return (
        <section id="legal-adviser" className="about section">
            <SectionTitleComponent
                title={section.title}
                subTitle={section.subTitle}
            />

            <div className="container">
                <div className="row gy-4">
                    <div
                        className="col-lg-4 text-center"
                        data-aos="fade-up"
                        data-aos-delay="100"
                        style={{ width: "400px", height: "300px" }}
                    >
                        <img
                            loading="lazy"
                            src="/assets/img/legal-adviser.webp"
                            alt="Mr. P.K. Date"
                            className="img-fluid border-radius-10px shadow-sm"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                        />
                    </div>
                    <div className="col-lg-8 content">
                        <p className="text-justify" data-aos="fade-up" data-aos-delay="200">
                            <span className="d-inline fs-6 fw-bold">Name:</span> <span>Mr. P.K. Date</span>
                        </p>
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <strong>Designation:</strong> Legal Adviser –
                            Provident Fund Matters
                        </p>
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <strong>Experience:</strong> 35 Years in the
                            Provident Fund Department
                        </p>

                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="500"
                        >
                            We are privileged to have Mr. P.K. Date, a
                            distinguished retired Provident Fund Commissioner,
                            serving as our Legal Adviser for provident
                            fund-related matters. With an illustrious career
                            spanning over 35 years in the Provident Fund
                            Department, he has earned a reputation as a subject
                            matter expert in the field.
                        </p>

                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="600"
                        >
                            Mr. Date has served in key PF offices across
                            Maharashtra and beyond, including Pune, Akurdi,
                            Vashi, Bandra, Thane, Solapur, Badoda, and several
                            others. This wide exposure has equipped him with
                            in-depth knowledge of PF operations, laws, and legal
                            compliance protocols.
                        </p>
                    </div>
                </div>
                <div className="row gy-4 mt-4">
                    <div className="col-lg-12 content">
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="700"
                        >
                            His expertise helps us manage a broad spectrum of PF
                            matters, including:
                        </p>

                        <p data-aos="fade-up" data-aos-delay="800">
                            <i className="bi bi-check2-circle"></i>&nbsp;&nbsp;
                            Legal Case Handling – strategic legal guidance in
                            PF-related cases
                        </p>
                        <p data-aos="fade-up" data-aos-delay="900">
                            <i className="bi bi-check2-circle"></i>&nbsp;&nbsp;
                            PF Inspections – ensuring compliance with
                            comprehensive legal oversight
                        </p>
                        <p data-aos="fade-up" data-aos-delay="1000">
                            <i className="bi bi-check2-circle"></i>&nbsp;&nbsp;
                            7A Enquiries – managing complex assessments and
                            delivering robust legal responses
                        </p>

                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="1100"
                        >
                            Mr. Date’s methodical approach, deep-rooted
                            knowledge of PF regulations, and professional
                            integrity ensure that legal and compliance matters
                            are handled with precision.
                        </p>
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="1200"
                        >
                            We are honored to have him on board—his
                            contributions are vital to strengthening our legal
                            framework and driving compliance excellence at
                            iTalent Outsourcing Services Pvt. Ltd.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
